/**
 * AI 모델 **별칭** — chat-server 와 8443 이 같은 낱말을 쓰기 위한 SSOT (설계 관문 G2).
 *
 * ## ★★★ 왜 별칭인가 — 실모델 이름을 저장하면 나중에 «전부» 손봐야 한다
 *
 * 사양 원문이 모델을 「GPT-5.4 Mini」라고 적어 뒀는데 **그런 이름은 없었다.** 그 값이 그대로
 * 에이전트 설정(판 E)과 대화 기록에 저장됐다면, 모델이 바뀔 때마다 저장된 행을 전부 고쳐야 한다.
 * 그래서 **사람이 고르고 저장하는 단위는 별칭**이고, 실모델은 배포가 정한다.
 * 설계가 「G2 를 판 E 보다 «먼저»」라고 못 박은 이유가 이것이다.
 *
 * ## 별칭이 셋인 이유
 *
 * 「어느 모델이 좋냐」는 사용자가 답할 물음이 아니다. 답할 수 있는 물음은
 * **「빠른 게 좋냐 · 깊은 게 좋냐」** 뿐이다 — 그래서 축이 하나(속도↔깊이)고 눈금이 셋이다.
 *
 * ## 실모델은 여기 없다
 *
 * 이 파일에는 «어느 별칭이 어느 모델인가»가 **없다.** 그것은 배포마다 다르고(운영은 지금
 * `cli.claude` 가 전역 선택이다) 모델 이름은 바뀐다 — 코드에 박으면 그 순간부터 거짓말이 된다.
 * 짝짓기는 chat-server 가 **env** 로 읽는다(`lib/ai-model-alias.ts`).
 */

/** 고를 수 있는 별칭. 순서가 곧 화면 차례다(빠른 것부터). */
export const AI_MODEL_ALIASES = ['fast', 'balanced', 'deep'] as const;
export type AiModelAlias = (typeof AI_MODEL_ALIASES)[number];

/** 화면에 보이는 이름. 곁말은 «무엇이 달라지나»를 말한다 — 모델 이름을 말하지 않는다. */
export const AI_MODEL_ALIAS_LABEL: Record<AiModelAlias, { label: string; hint: string }> = {
  fast: { label: '빠르게', hint: '짧은 답을 빨리' },
  balanced: { label: '고르게', hint: '보통' },
  deep: { label: '깊게', hint: '오래 걸려도 자세히' },
};

export function isAiModelAlias(v: unknown): v is AiModelAlias {
  return typeof v === 'string' && (AI_MODEL_ALIASES as readonly string[]).includes(v);
}
